(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ho-newsletter-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const offer = document.querySelector('[data-ho-email-offer]');
    if (!offer || offer.dataset.ready) return;
    offer.dataset.ready = 'true';
    const form = offer.closest('form');
    const panel = offer.querySelector('[data-ho-offer-panel]');
    const teaser = offer.querySelector('[data-ho-offer-teaser]');
    const closeButton = offer.querySelector('[data-ho-offer-close]');
    const copyButton = offer.querySelector('[data-ho-offer-copy]');
    copyButton?.addEventListener('click', async () => {
      const code = offer.querySelector('[data-ho-offer-code]');
      const status = offer.querySelector('[data-ho-copy-status]');
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(code.textContent.trim());
        status.textContent = copyButton.dataset.copied;
      } catch (_) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(code);
        selection.removeAllRanges();
        selection.addRange(range);
        status.textContent = copyButton.dataset.manualCopy;
      }
      status.hidden = false;
    });
    const key = 'ho-email-offer-v1';
    const visitKey = key + '-visit';
    const pendingKey = key + '-pending';
    const shownKey = key + '-shown';
    let storageAvailable = true;
    let suppression = null;
    let shownThisSession = false;
    let visit = { pages: [], engaged: 0 };
    let manualOrigin = null;
    let interval = null;
    const mobile = window.matchMedia('(max-width: 600px)');
    try {
      const checkKey = key + '-check';
      localStorage.setItem(checkKey, '1');
      localStorage.removeItem(checkKey);
      suppression = localStorage.getItem(key);
      shownThisSession = sessionStorage.getItem(shownKey) === 'true';
      const saved = JSON.parse(sessionStorage.getItem(visitKey) || 'null');
      if (saved && Array.isArray(saved.pages) && Number.isFinite(saved.engaged)) visit = saved;
      if (offer.dataset.autoPage !== 'false' && !visit.pages.includes(location.pathname)) visit.pages.push(location.pathname);
      sessionStorage.setItem(visitKey, JSON.stringify(visit));
    } catch (_) { storageAvailable = false; }
    const remember = value => {
      suppression = value;
      try { localStorage.setItem(key, value); } catch (_) {}
    };
    const open = manual => {
      if (manual) {
        const active = document.activeElement;
        manualOrigin = active !== document.body && active !== document.documentElement && !panel.contains(active) ? active : null;
      }
      shownThisSession = true;
      try { sessionStorage.setItem(shownKey, 'true'); } catch (_) {}
      panel.hidden = false;
      teaser.hidden = true;
      teaser.setAttribute('aria-expanded', 'true');
      if (manual) closeButton.focus({ preventScroll: true });
    };
    const close = () => {
      const focusInside = panel.contains(document.activeElement);
      panel.hidden = true;
      teaser.setAttribute('aria-expanded', 'false');
      if (offer.dataset.success !== 'true') {
        remember('dismissed');
        teaser.hidden = offer.dataset.autoPage === 'false';
      } else teaser.hidden = true;
      if (manualOrigin?.isConnected && !panel.contains(manualOrigin)) manualOrigin.focus({ preventScroll: true });
      else if (focusInside && !teaser.hidden) teaser.focus({ preventScroll: true });
      else if (focusInside) {
        const target = document.querySelector('main,#site-main,[role="main"]') || document.body;
        const hadTabIndex = target.hasAttribute('tabindex');
        if (!hadTabIndex) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (!hadTabIndex) target.removeAttribute('tabindex');
      }
      manualOrigin = null;
    };
    const interfering = () => {
      const active = document.activeElement;
      if (active?.matches('input,textarea,select,[contenteditable="true"]')) return true;
      const candidates = document.querySelectorAll('dialog[open],[aria-modal="true"],[data-atc-banner],.ho-cart-toast:not([hidden]),[data-ho-cart-flyout]:not([hidden])');
      return Array.from(candidates).some(element => {
        if (offer.contains(element)) return false;
        const style = getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && rect.height > 0 && rect.width > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < innerHeight && rect.left < innerWidth;
      });
    };
    const hideEntries = () => document.querySelectorAll('[data-ho-offer-entry]').forEach(entry => { entry.hidden = true; });
    const openManually = () => {
      if (suppression === 'subscribed' || offer.dataset.success === 'true') return;
      open(true);
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest?.('[data-ho-offer-open]');
      if (!trigger) return;
      event.preventDefault();
      openManually();
    });
    document.addEventListener('ho:newsletter:open', openManually);
    teaser.addEventListener('click', openManually);
    closeButton.addEventListener('click', close);
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) close(); });
    const openFromHash = () => { if (location.hash === '#ho-newsletter-offer') open(true); };
    window.addEventListener('hashchange', openFromHash);
    window.addEventListener('storage', event => {
      if (event.key !== key || !event.newValue) return;
      suppression = event.newValue;
      panel.hidden = true;
      teaser.hidden = suppression !== 'dismissed' || offer.dataset.autoPage === 'false';
      if (suppression === 'subscribed') hideEntries();
      teaser.setAttribute('aria-expanded', 'false');
      window.clearInterval(interval);
    });
    form.addEventListener('submit', () => {
      try { sessionStorage.setItem(pendingKey, 'true'); } catch (_) {}
      const returnTo = form.querySelector('[name="return_to"]');
      if (returnTo) returnTo.value = location.pathname + location.search + '#ho-newsletter-offer';
      const submit = offer.querySelector('[data-ho-offer-submit]');
      if (submit) { submit.disabled = true; submit.textContent = submit.dataset.loadingLabel; }
    });
    if (offer.dataset.success === 'true') {
      let pending = false;
      try { pending = sessionStorage.getItem(pendingKey) === 'true'; sessionStorage.removeItem(pendingKey); } catch (_) {}
      remember('subscribed');
      hideEntries();
      if (pending || location.hash === '#ho-newsletter-offer') open(true);
      return;
    }
    if (offer.dataset.errors === 'true') { open(true); return; }
    if (location.hash === '#ho-newsletter-offer') { open(true); return; }
    if (suppression === 'subscribed') { hideEntries(); return; }
    if (offer.dataset.autoPage === 'false') return;
    if (suppression === 'dismissed') { teaser.hidden = false; return; }
    if (!storageAvailable || offer.dataset.designMode === 'true') return;
    if (shownThisSession) { teaser.hidden = false; return; }
    let lastTick = performance.now();
    interval = window.setInterval(() => {
      const now = performance.now();
      if (!document.hidden) visit.engaged += Math.min(now - lastTick, 1500);
      lastTick = now;
      try { sessionStorage.setItem(visitKey, JSON.stringify(visit)); } catch (_) { window.clearInterval(interval); return; }
      if (suppression || !panel.hidden) { window.clearInterval(interval); return; }
      if (visit.pages.length < 2 || visit.engaged < 20000 || document.hidden || interfering()) return;
      if (mobile.matches) {
        teaser.hidden = false;
        shownThisSession = true;
        try { sessionStorage.setItem(shownKey, 'true'); } catch (_) {}
      }
      else open(false);
      window.clearInterval(interval);
    }, 1000);
    window.addEventListener('pagehide', () => { window.clearInterval(interval); }, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ho-pleached-calculator"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__hoPleachedCalculatorReady) return;
    if (typeof HTMLDialogElement === 'undefined' || typeof HTMLDialogElement.prototype.showModal !== 'function') return;
    window.__hoPleachedCalculatorReady = true;

    let dialog;
    let heading;
    let closeButton;
    let frame;
    let opener;

    function createDialog() {
      dialog = document.createElement('dialog');
      dialog.className = 'ho-pleached-calculator-dialog';
      dialog.setAttribute('aria-labelledby', 'ho-pleached-calculator-title');

      const header = document.createElement('div');
      header.className = 'ho-pleached-calculator-dialog__header';

      heading = document.createElement('h2');
      heading.id = 'ho-pleached-calculator-title';
      heading.className = 'ho-pleached-calculator-dialog__title';

      closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'ho-pleached-calculator-dialog__close';
      closeButton.setAttribute('autofocus', '');
      closeButton.addEventListener('click', () => dialog.close());

      frame = document.createElement('iframe');
      frame.className = 'ho-pleached-calculator-dialog__frame';
      frame.setAttribute('allow', 'clipboard-write');
      frame.setAttribute('referrerpolicy', 'no-referrer');

      header.append(heading, closeButton);
      dialog.append(header, frame);
      document.body.append(dialog);

      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
          dialog.close();
        }
      });

      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ho-pleached-calculator-open');
        if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      });
    }

    window.addEventListener('message', event => {
      if (!dialog || !dialog.open || event.origin !== 'https://pleached.netlify.app' || event.source !== frame.contentWindow || event.data !== 'ho-pleached-calculator-close') return;
      dialog.close();
    });

    document.addEventListener('click', event => {
      const link = event.target instanceof Element ? event.target.closest('a.ho-pleached-calculator') : null;
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!dialog) createDialog();

      heading.textContent = link.textContent.trim();
      closeButton.textContent = link.dataset.closeLabel;
      frame.title = heading.textContent;
      opener = link;

      if (!dialog.open) dialog.showModal();
      event.preventDefault();
      document.documentElement.classList.add('ho-pleached-calculator-open');
      if (!frame.hasAttribute('src')) frame.src = 'https://pleached.netlify.app/';
      closeButton.focus({ preventScroll: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ho-shop-all-type-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ho-shop-all-type-filter')) {
    customElements.define('ho-shop-all-type-filter', class extends HTMLElement {
      connectedCallback() {
        if (this._hoConnected) return;
        this._hoConnected = true;
        this._hoClick = (event) => {
          const link = event.target instanceof Element ? event.target.closest('a[data-ho-values]') : null;
          if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (link.getAttribute('aria-disabled') === 'true') return;
          const target = new URL(link.href, window.location.href);
          const current = new URL(window.location.href);
          ['sort_by','preview_theme_id'].forEach(key => { if (current.searchParams.has(key)) target.searchParams.set(key,current.searchParams.get(key)); });
          if (current.pathname.endsWith('/search') && !current.searchParams.has('ho_quiz_search')) {
            ['q','type','options[prefix]'].forEach(key => { if (current.searchParams.has(key)) target.searchParams.set(key,current.searchParams.get(key)); });
          }
          if (current.searchParams.has('ho_quiz_search')) {
            target.pathname = current.pathname.replace(/search$/, 'collections/all');
            target.searchParams.delete('q'); target.searchParams.delete('type'); target.searchParams.delete('ho_quiz_search');
          }
          Array.from(target.searchParams.keys()).forEach(key => { if (key.startsWith('filter.') || key.startsWith('ho_tree_')) target.searchParams.delete(key); });
          target.searchParams.delete('page');
          target.searchParams.delete('ho_category');
          target.searchParams.delete('ho_tree_page');
          const eligibleTreeTypes = ['Full Standard Trees', 'Half Standard Trees', 'Multi-Stem Trees', 'Feathered Trees', 'Palm Trees'];
          const keepTreeCriteria = link.dataset.hoCategory === 'trees' ||
            (link.closest('[data-ho-styles="trees"]') && link.dataset.hoValues.split(',').some(value => eligibleTreeTypes.includes(value)));
          if (!keepTreeCriteria) {
            ['spread', 'crown', 'height', 'roots', 'lifespan', 'biodiversity', 'carbon'].forEach(key => target.searchParams.delete('ho_tree_' + key));
          }
          target.searchParams.delete('filter.p.product_type');
          link.dataset.hoValues.split(',').filter(Boolean).forEach(value => target.searchParams.append('filter.p.product_type', value));
          window.location.assign(target.href);
        };
        this._hoQueueSync = () => {
          if (this._hoFrame) return;
          this._hoFrame = window.requestAnimationFrame(() => {
            this._hoFrame = 0;
            this._hoSync();
          });
        };
        this.addEventListener('click', this._hoClick);
        window.addEventListener('popstate', this._hoQueueSync);
        this._hoObserver = new MutationObserver(this._hoQueueSync);
        this._hoObserver.observe(this.closest('[data-section-type], [id^="shopify-section-"]') || this.parentElement, { childList:true, subtree:true });
        this._hoSync();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._hoClick);
        window.removeEventListener('popstate', this._hoQueueSync);
        this._hoObserver?.disconnect();
        if (this._hoFrame) window.cancelAnimationFrame(this._hoFrame);
        this._hoFrame = 0;
        this._hoConnected = false;
      }

      _hoSync() {
        const explicitValues = new URLSearchParams(window.location.search).getAll('filter.p.product_type').flatMap(value => value.split(',')).filter(Boolean);
        const selected = new Set(explicitValues.length ? explicitValues : (this.dataset.hoCollectionValues || '').split(',').filter(Boolean));
        const categories = Array.from(this.querySelectorAll('[data-ho-category]'));
        const family = selected.size ? categories.find(link => link.dataset.hoCategory !== 'all' && Array.from(selected).every(value => link.dataset.hoValues.split(',').includes(value)))?.dataset.hoCategory : '';
        categories.forEach(link => link.setAttribute('aria-current', String(link.dataset.hoCategory === 'all' ? selected.size === 0 : link.dataset.hoCategory === family)));
        const styleFamily = !selected.size && this.dataset.hoHideUnfilteredStyles === 'true' ? '' : (family || 'all');
        this.querySelectorAll('[data-ho-styles]').forEach(group => { group.hidden = group.dataset.hoStyles !== styleFamily; });
        this.querySelectorAll('[data-ho-style]').forEach(link => {
          const values = new Set(link.dataset.hoValues.split(',').filter(Boolean));
          link.setAttribute('aria-current', String(values.size === selected.size && Array.from(values).every(value => selected.has(value))));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ho-trade-savings"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function variantId(value) {
    const raw = String(value == null ? '' : value);
    const match = /^(?:gid:\/\/shopify\/ProductVariant\/)?([1-9]\d*)$/.exec(raw);
    return match ? match[1] : null;
  }

  function integer(value, minimum) {
    if (typeof value !== 'number' && typeof value !== 'string') return null;
    if (typeof value === 'string' && !/^\d+$/.test(value)) return null;
    const number = Number(value);
    return Number.isSafeInteger(number) && number >= minimum ? number : null;
  }

  function decimalCents(value) {
    if (typeof value !== 'string') return null;
    const match = /^(\d+)(?:\.(\d+))?$/.exec(value);
    if (!match) return null;
    const fraction = match[2] || '';
    if (fraction.length > 2 && /[1-9]/.test(fraction.slice(2))) return null;
    const cents = BigInt(match[1]) * 100n + BigInt((fraction + '00').slice(0, 2));
    return cents <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(cents) : null;
  }

  function safeProduct(left, right) {
    if (integer(left, 0) === null || integer(right, 0) === null) return null;
    const amount = BigInt(left) * BigInt(right);
    return amount <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(amount) : null;
  }

  function comparison(input) {
    const retail = input.retail;
    const account = integer(input.accountPrice, 0);
    const minimum = integer(input.minimum, 1);
    const discount = integer(input.discount, 0);
    if (!retail || integer(retail.price, 1) === null || account === null || minimum === null || discount === null) return null;
    const sale = retail.compareAt !== null && retail.compareAt > retail.price;
    const eligible = input.retailEligible === true && !sale;
    let reference, accountAmount;
    if (input.kind === 'fixed') {
      const subtotal = safeProduct(retail.price, minimum);
      accountAmount = safeProduct(account, minimum);
      if (subtotal === null || accountAmount === null) return null;
      reference = Math.max(0, subtotal - (eligible ? discount : 0));
    } else if (input.kind === 'percentage') {
      if (discount > 100) return null;
      const percentage = eligible ? discount : 0;
      reference = Number((BigInt(retail.price) * BigInt(100 - percentage) + 99n) / 100n);
      accountAmount = account;
    } else {
      return null;
    }
    return {
      retail: reference,
      account: accountAmount,
      state: reference > accountAmount ? 'saving' : reference === accountAmount ? 'equal' : 'retail-lower'
    };
  }

  function createRetailLoader(fetcher, origin, schedule) {
    const cache = new Map();
    const pending = new Map();
    let scheduled = false;
    const enqueue = schedule || (callback => queueMicrotask(callback));
    const query = 'query HarrodRetailComparison($ids: [ID!]!, $country: CountryCode!) @inContext(country: $country) { nodes(ids: $ids) { ... on ProductVariant { id price { amount currencyCode } compareAtPrice { amount currencyCode } } } }';

    async function fetchBatch(ids, country, currency) {
      const result = new Map();
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetcher(origin + '/api/2026-10/graphql.json', {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          signal: controller.signal,
          body: JSON.stringify({ query, variables: { ids: ids.map(id => 'gid://shopify/ProductVariant/' + id), country } })
        });
        if (!response.ok) return result;
        const body = await response.json();
        if (body.errors && body.errors.length) return result;
        if (!Array.isArray(body.data && body.data.nodes)) return result;
        body.data.nodes.forEach(node => {
          if (!node) return;
          const id = variantId(node.id);
          if (!id || !ids.includes(id) || !node.price || node.price.currencyCode !== currency) return;
          const price = decimalCents(node.price.amount);
          if (price === null) return;
          let compareAt = null;
          if (node.compareAtPrice) {
            if (node.compareAtPrice.currencyCode !== currency) return;
            compareAt = decimalCents(node.compareAtPrice.amount);
            if (compareAt === null) return;
          }
          result.set(id, { price, compareAt, currency });
        });
      } catch (_) {
        return result;
      } finally {
        clearTimeout(timeout);
      }
      return result;
    }

    function flush() {
      scheduled = false;
      const groups = Array.from(pending.values());
      pending.clear();
      groups.forEach(group => {
        const entries = Array.from(group.entries.entries());
        for (let offset = 0; offset < entries.length; offset += 100) {
          const chunk = entries.slice(offset, offset + 100);
          fetchBatch(chunk.map(entry => entry[0]), group.country, group.currency).then(references => {
            chunk.forEach(([id, resolve]) => resolve(references.get(id) || null));
          }).catch(() => chunk.forEach(([, resolve]) => resolve(null)));
        }
      });
    }

    return {
      request(values, country, currency) {
        const ids = Array.from(new Set(values.map(variantId).filter(Boolean)));
        if (!/^[A-Z]{2}$/.test(country) || !/^[A-Z]{3}$/.test(currency)) return Promise.resolve(new Map(ids.map(id => [id, null])));
        const context = country + '|' + currency;
        if (!pending.has(context)) pending.set(context, { country, currency, entries: new Map() });
        const group = pending.get(context);
        const promises = ids.map(id => {
          const key = context + '|' + id;
          if (!cache.has(key)) {
            cache.set(key, new Promise(resolve => group.entries.set(id, resolve)));
          }
          return cache.get(key).then(value => [id, value]);
        });
        if (group.entries.size && !scheduled) {
          scheduled = true;
          enqueue(flush);
        }
        if (!group.entries.size) pending.delete(context);
        return Promise.all(promises).then(entries => new Map(entries));
      }
    };
  }

  const exported = { variantId, integer, decimalCents, safeProduct, comparison, createRetailLoader };
  if (typeof module !== 'undefined' && module.exports) module.exports = exported;
  if (typeof window === 'undefined' || !window.customElements || !window.HTMLElement) return;
  if (window.customElements.get('ho-trade-savings')) return;

  const retailLoader = createRetailLoader(window.fetch.bind(window), window.location.origin);
  const defaults = {
    retailUnavailable: '',
    retail: 'Retail quantity price',
    account: 'Your account price',
    fixedRetail: 'Retail unit price before retail basket offers',
    equal: 'Equal price',
    retailLower: 'Retail offer is lower',
    unavailable: 'Select an available option to see your trade price.'
  };

  window.customElements.define('ho-trade-savings', class extends window.HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.native = this.hasAttribute('data-ho-trade-native');
      this.references = new Map();
      this.retailLoaded = false;
      try {
        const source = this.querySelector('[data-ho-trade-data]');
        this.config = source ? JSON.parse(source.textContent) : {};
      } catch (_) {
        this.config = {};
      }
      this.labels = Object.assign({}, defaults, this.config.labels || {});
      if (typeof this.config.unavailable === 'string') this.labels.unavailable = this.config.unavailable;
      this.variants = new Map();
      Object.entries(this.config.variants || {}).forEach(([id, value]) => {
        const normalized = variantId(id);
        if (normalized && value) this.variants.set(normalized, value);
      });
      this.form = this.native ? this.closest('form') : null;
      this.selection = this.form && this.form.querySelector('variant-selection');
      this.abort = new AbortController();
      this.refresh = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.render());
      };
      if (this.form) {
        this.form.addEventListener('input', this.refresh, { signal: this.abort.signal });
        this.form.addEventListener('change', this.refresh, { signal: this.abort.signal });
      }
      if (this.selection) {
        this.observer = new MutationObserver(this.refresh);
        this.observer.observe(this.selection, { attributes: true, attributeFilter: ['variant'] });
      }
      const ids = this.native ? Array.from(this.variants.keys()) : [this.dataset.variantId];
      this.resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(() => this.scheduleFit()) : null;
      if (this.resizeObserver) this.resizeObserver.observe(this);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { if (this.isConnected) this.scheduleFit(); });
      this.render();
      const request = retailLoader.request(ids, this.dataset.retailCountry || '', this.dataset.currency || '');
      this.retailRequest = request;
      request.then(references => {
        if (!this.isConnected || this.retailRequest !== request) return;
        this.references = references;
        this.retailLoaded = true;
        this.render();
      }).catch(() => {
        if (!this.isConnected || this.retailRequest !== request) return;
        this.retailLoaded = true;
        this.render();
      });
    }

    disconnectedCallback() {
      this.abort && this.abort.abort();
      this.observer && this.observer.disconnect();
      this.resizeObserver && this.resizeObserver.disconnect();
      cancelAnimationFrame(this.fitFrame);
      cancelAnimationFrame(this.frame);
      this.ready = false;
      this.retailRequest = null;
    }

    current() {
      if (this.native) {
        const selected = this.selection && this.selection.getAttribute('variant');
        const input = this.form && this.form.querySelector('[name="id"]');
        const id = variantId(selected || (input && input.value) || this.dataset.variantId);
        return { id, variant: this.variants.get(id) };
      }
      return {
        id: variantId(this.dataset.variantId),
        variant: { price: integer(this.dataset.accountPrice, 0), available: this.dataset.available === 'true' }
      };
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: this.dataset.currency }).format(cents / 100);
      } catch (_) {
        return (cents / 100).toFixed(2) + ' ' + (this.dataset.currency || '');
      }
    }

    pair(scope, strikeSelector, plainSelector, accountSelector, item, fallback) {
      const strike = scope.querySelector(strikeSelector);
      const plain = scope.querySelector(plainSelector);
      const account = scope.querySelector(accountSelector);
      [strike, plain].forEach(element => {
        if (element) {
          element.hidden = true;
          element.textContent = '';
        }
      });
      if (account) account.textContent = fallback === null ? '–' : this.money(fallback);
      const pair = account && account.closest('[data-ho-price-pair]');
      if (pair) {
        pair.removeAttribute('title');
        pair.removeAttribute('aria-label');
      }
      if (!item) return;
      if (account) account.textContent = this.money(item.account);
      const reference = item.state === 'saving' ? strike : plain;
      if (reference) {
        reference.textContent = this.money(item.retail);
        reference.hidden = false;
      }
      if (pair) {
        const retailLabel = this.dataset.fixedRetailReference === 'true' ? this.labels.fixedRetail : this.labels.retail;
        const qualifier = item.state === 'equal' ? this.labels.equal : item.state === 'retail-lower' ? this.labels.retailLower : '';
        const description = retailLabel + ': ' + this.money(item.retail) + '. ' + this.labels.account + ': ' + this.money(item.account) + '.' + (qualifier ? ' ' + qualifier + '.' : '');
        pair.title = description;
        pair.setAttribute('aria-label', description);
      }
    }

    scheduleFit() {
      cancelAnimationFrame(this.fitFrame);
      this.fitFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.querySelectorAll('[data-ho-price-pair]').forEach(pair => this.fitPair(pair));
      });
    }

    fitPair(pair) {
      const account = pair.querySelector('[data-ho-account-tier]');
      const reference = pair.querySelector('[data-ho-retail-strike]:not([hidden]), [data-ho-retail-plain]:not([hidden])');
      if (!account) return;
      account.style.fontSize = '';
      pair.style.transform = '';
      pair.style.transformOrigin = '';
      pair.style.justifyContent = '';
      pair.removeAttribute('data-ho-fit-compressed');
      if (reference) reference.style.fontSize = '';
      if (!reference || !pair.parentElement || pair.parentElement.clientWidth <= 0) return;
      const styles = getComputedStyle(pair.parentElement);
      const available = pair.parentElement.clientWidth - (parseFloat(styles.paddingLeft) || 0) - (parseFloat(styles.paddingRight) || 0);
      if (available <= 0) return;
      const base = parseFloat(getComputedStyle(account).fontSize);
      const measure = () => account.getBoundingClientRect().width + reference.getBoundingClientRect().width + (parseFloat(getComputedStyle(pair).columnGap) || base * .25);
      if (!Number.isFinite(base) || base <= 0) return;
      let width = measure();
      if (width > available) {
        account.style.fontSize = Math.max(base * .8, base * available / width) + 'px';
        width = measure();
      }
      if (width > available) {
        const accountWidth = account.getBoundingClientRect().width;
        const referenceWidth = reference.getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(pair).columnGap) || base * .25;
        reference.style.fontSize = Math.max(base * .6, base * .72 * Math.max(0, available - accountWidth - gap) / Math.max(1, referenceWidth)) + 'px';
        width = measure();
      }
      if (width > available) {
        pair.style.justifyContent = 'flex-start';
        pair.style.transform = 'scaleX(' + Math.max(.1, Math.min(1, available / width)) + ')';
        pair.style.transformOrigin = 'left center';
        pair.setAttribute('data-ho-fit-compressed', 'true');
      }
    }

    syncPickerReference(id, retail) {
      const row = this.closest('[data-ho-vp-row]');
      const picker = row && row.closest('ho-variant-picker');
      if (!picker) return;
      const rows = [row];
      picker.querySelectorAll('[data-ho-quick-row]').forEach(quickRow => {
        if (variantId(quickRow.dataset.variantId) === id) rows.push(quickRow);
      });
      rows.forEach(target => {
        if (retail && integer(retail.price, 1) !== null && retail.currency === this.dataset.currency) target.dataset.retailPriceCents = String(retail.price);
        else delete target.dataset.retailPriceCents;
      });
      const update = () => {
        if (!this.isConnected || !picker.isConnected) return;
        if (typeof picker.updatePrice === 'function') picker.updatePrice(row);
        if (typeof picker.updateQuickOrder === 'function') picker.updateQuickOrder();
      };
      if (window.customElements.get('ho-variant-picker')) update();
      else if (!this.pickerDefinitionPending) {
        this.pickerDefinitionPending = true;
        window.customElements.whenDefined('ho-variant-picker').then(() => {
          this.pickerDefinitionPending = false;
          update();
        });
      }
    }

    render() {
      const current = this.current();
      const available = Boolean(current.variant && current.variant.available === true && integer(current.variant.price, 0) !== null);
      const account = available ? current.variant.price : null;
      const candidate = available && this.references.get(current.id);
      const retail = candidate && candidate.currency === this.dataset.currency && integer(candidate.price, 1) !== null ? candidate : null;
      const summary = retail && account !== null ? {
        retail: retail.price,
        account,
        state: retail.price > account ? 'saving' : retail.price === account ? 'equal' : 'retail-lower'
      } : null;
      this.pair(this, '[data-ho-retail-original]', '[data-ho-retail-original-plain]', '[data-ho-account-unit]', summary, account);
      this.querySelectorAll('[data-ho-comparison-row]').forEach(row => {
        const minimum = integer(row.dataset.minimum, 1);
        const item = available ? comparison({
          retail,
          accountPrice: account,
          kind: this.dataset.kind,
          minimum,
          discount: integer(row.dataset.discount, 0),
          retailEligible: this.dataset.retailEligible === 'true'
        }) : null;
        const fallback = account === null ? null : this.dataset.kind === 'fixed' ? safeProduct(account, minimum) : account;
        this.pair(row, '[data-ho-retail-strike]', '[data-ho-retail-plain]', '[data-ho-account-tier]', item, fallback);
        const note = row.querySelector('[data-ho-retail-tier-note]');
        if (note) {
          note.textContent = item && item.state === 'equal' ? this.labels.equal : item && item.state === 'retail-lower' ? this.labels.retailLower : '';
          note.hidden = note.textContent === '';
        }
      });
      const status = this.querySelector('[data-ho-trade-status]');
      if (status) status.textContent = !available ? this.labels.unavailable : '';
      this.scheduleFit();
      this.syncPickerReference(current.id, retail);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ho-attribute-icons'))customElements.define('ho-attribute-icons',class extends HTMLElement{
 connectedCallback(){if(this._ready)return;const run=()=>requestAnimationFrame(()=>this.init());if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();}
 init(){if(this._ready||!this.isConnected)return;this._ready=true;this._abort=new AbortController();const options={signal:this._abort.signal};this.querySelectorAll('.ho-attr__item').forEach(item=>{const button=item.querySelector('button, a.ho-carbon-report');button.removeAttribute('title');item.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&!this.pinned)this.open(item);},options);item.addEventListener('pointerleave',()=>{if(!this.pinned&&document.activeElement!==button)this.close();},options);button.addEventListener('focus',()=>this.open(item),options);button.addEventListener('blur',()=>{if(!this.pinned)this.close();},options);button.addEventListener('click',event=>{if(button.tagName==='A'){this.close();if(this.reportDialog&&event.button===0&&!event.ctrlKey&&!event.metaKey&&!event.shiftKey&&!event.altKey){event.preventDefault();this.openReport();}return;}if(this.pinned===item){this.close();return;}this.open(item);this.pinned=item;},options);});this.initReport(options);this.addEventListener('keydown',event=>{if(event.key==='Escape'&&!this.reportDialog?.open){event.preventDefault();this.close();}},options);document.addEventListener('pointerdown',event=>{if(!this.contains(event.target))this.close();},options);window.addEventListener('resize',()=>this.close(),options);window.addEventListener('scroll',()=>this.close(),{...options,passive:true});}
 open(item){if(this.item!==item)this.close();this.item=item;const button=item.querySelector('button, a.ho-carbon-report'),tip=item.querySelector('[role=tooltip]');tip.hidden=false;button.dataset.open='true';const rect=button.getBoundingClientRect(),width=tip.offsetWidth,height=tip.offsetHeight;tip.style.left=Math.max(12,Math.min(rect.left+rect.width/2-width/2,window.innerWidth-width-12))+'px';tip.style.top=(rect.bottom+height+12<window.innerHeight?rect.bottom+7:Math.max(12,rect.top-height-7))+'px';}
 close(){if(this.item){this.item.querySelector('[role=tooltip]').hidden=true;delete this.item.querySelector('button, a.ho-carbon-report').dataset.open;}this.item=null;this.pinned=null;}
 initReport(options){
  this.reportDialog=this.querySelector('.ho-report-dialog');if(!this.reportDialog)return;
  this.reportTrigger=this.querySelector('.ho-carbon-report');
  this.reportDialog.querySelector('[data-report-close]').addEventListener('click',()=>this.reportDialog.close(),options);
  this.reportDialog.addEventListener('click',event=>{if(event.target===this.reportDialog)this.reportDialog.close();},options);
  this.reportDialog.addEventListener('close',()=>this.reportTrigger.focus({preventScroll:true}),options);
  this.reportDialog.querySelector('[data-report-download]').addEventListener('click',event=>this.downloadReport(event.currentTarget),options);
 }
 openReport(){
  const image=this.reportDialog.querySelector('[data-report-image]');if(!image.src)image.src=image.dataset.src;
  this.reportDialog.querySelector('[data-report-status]').textContent='';
  this.reportDialog.showModal();
 }
 async downloadReport(button){
  const status=this.reportDialog.querySelector('[data-report-status]');button.disabled=true;button.setAttribute('aria-busy','true');status.textContent=status.dataset.loading;
  try{
   const response=await fetch(this.reportTrigger.href,{signal:this._abort.signal});if(!response.ok)throw new Error('Report download failed');
   const blob=await response.blob();if(!blob.type.startsWith('image/')&&blob.type!=='application/pdf')throw new Error('Invalid report file');
   const url=URL.createObjectURL(blob),link=document.createElement('a');
   const extension={'image/jpeg':'jpg','image/png':'png','image/webp':'webp','application/pdf':'pdf'}[blob.type]||'jpg';
   link.href=url;link.download=button.dataset.filename+'.'+extension;this.reportDialog.append(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);
   status.textContent=status.dataset.ready;
  }catch(error){if(error.name!=='AbortError')status.textContent=status.dataset.error;}
  finally{button.disabled=false;button.removeAttribute('aria-busy');}
 }
 disconnectedCallback(){if(this.reportDialog?.open)this.reportDialog.close();this._abort?.abort();this._ready=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

})();
